// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./sass/vapor/_Checkbox.scss
// module id = 391
// module chunks = 88 89